module["exports"] = [
  "5###-###-###",
  "5##.###.###",
  "5## ### ###",
  "5########"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/phone_number/formats.js
// module id = 690
// module chunks = 0